import React, { useState } from 'react'
import { isValidEmail, setStoredEmail } from '../../../services/user'

export function EmailGate({ onSubmit }: { onSubmit: (email: string) => void }) {
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    const trimmed = email.trim()
    if (!isValidEmail(trimmed)) {
      setError('Please enter a valid @kainos.com email')
      return
    }
    setStoredEmail(trimmed)
    onSubmit(trimmed.toLowerCase())
  }

  return (
    <div className="bg-an-surface border border-an-line-mid rounded-xl px-5 py-4 flex items-center gap-4 animate-[an-in_0.15s_ease]">
      <div className="flex-1 min-w-0">
        <div className="text-[13px] font-semibold text-an-ink tracking-[-0.01em]">Enter your email to track your reviews</div>
        <div className="text-[11.5px] text-an-ink-3 mt-0.5">Each person sees their own review status independently.</div>
      </div>
      <form onSubmit={handleSubmit} className="flex items-center gap-2 shrink-0">
        <div className="flex flex-col">
          <input
            type="email"
            value={email}
            onChange={e => { setEmail(e.target.value); setError('') }}
            placeholder="you@kainos.com"
            className="px-3 py-[7px] rounded-lg border border-an-line-mid bg-an-surface-2 text-an-ink text-[13px] w-[220px] outline-none focus:border-an-accent transition-colors"
          />
          {error && <span className="text-[11px] text-an-red mt-1">{error}</span>}
        </div>
        <button
          type="submit"
          className="px-4 py-[7px] rounded-lg border-none bg-an-accent text-white text-[13px] font-semibold cursor-pointer"
        >
          Continue
        </button>
      </form>
    </div>
  )
}
